exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".von-popover-close{position:absolute;top:16px;right:14px}.von-popover-close svg{width:9px;height:9px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/popover/close.vue
// module id = 170
// module chunks = 0